module.exports = __webpack_public_path__ + "static/media/content-sketch-icon.9bbfe474.svg";